import styled from "styled-components";

export const PromptConfigViewContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`;

export const LeftColumn = styled.div`
  display: flex;
  width: 100%;
  height: calc(100vh - 400px);
`;

export const RightColumn = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`;